import ReactDOM from "react-dom";
import $ from "jquery";
import moment from "moment";
import { addDays, subDays } from "date-fns";
import ApiGateway from "./ApiGateway";
import _ from "lodash";

class ERPUtils {
  constructor() {
    this._loadingHtml =
      '<div class="app-ui-loader" style="position:absolute;z-index: 1000;top:0px;left:0px;background-color: rgba(0,0,0,.1);width: 100%;height: 100%;">' +
      '<div style="position:absolute;width: 70px;height: 70px;border-radius: 35px;background-color: #F5F5F5;left: 50%;top: 50%;margin-top:  -35px;margin-left: -35px;">' +
      '<svg class="lds-curve-bars" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="translate(50,50)"><circle cx="0" cy="0" r="8.333333333333334" fill="none" stroke="#0051a2" stroke-width="5" stroke-dasharray="26.179938779914945 26.179938779914945" transform="rotate(222.749)">' +
      '<animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="0" repeatCount="indefinite"></animateTransform>' +
      '</circle><circle cx="0" cy="0" r="16.666666666666668" fill="none" stroke="#1b75be" stroke-width="5" stroke-dasharray="52.35987755982989 52.35987755982989" transform="rotate(306.782)">' +
      '<animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.2" repeatCount="indefinite"></animateTransform>' +
      '</circle><circle cx="0" cy="0" r="25" fill="none" stroke="#408ee0" stroke-width="5" stroke-dasharray="78.53981633974483 78.53981633974483" transform="rotate(359.939)">' +
      '<animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.4" repeatCount="indefinite"></animateTransform>' +
      '</circle><circle cx="0" cy="0" r="33.333333333333336" fill="none" stroke="#89bff8" stroke-width="5" stroke-dasharray="104.71975511965978 104.71975511965978" transform="rotate(49.7418)">' +
      '<animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.6" repeatCount="indefinite"></animateTransform>' +
      '</circle><circle cx="0" cy="0" r="41.666666666666664" fill="none" stroke="#e3f1ff" stroke-width="5" stroke-dasharray="130.89969389957471 130.89969389957471" transform="rotate(133.175)">' +
      '<animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.8" repeatCount="indefinite"></animateTransform>' +
      "</circle></g>" +
      "</svg>" +
      "</div>" +
      "</div>";

    this.getUniqueID = this.getUniqueID.bind(this);
    this.findComponentByNode = this.findComponentByNode.bind(this);
    this.params = this.params.bind(this);
    this.loading = this.loading.bind(this);
    this.queryString = this.queryString.bind(this);
    this.isUndefinedOrNull = this.isUndefinedOrNull.bind(this);
    this.isNullOrEmpty = this.isNullOrEmpty.bind(this);
    this.isNullorWhiteSpace = this.isNullorWhiteSpace.bind(this);
    this.getSelect2ItemByID = this.getSelect2ItemByID.bind(this);

    /*----- Unique ID Generator -----*/
    function IDGeneratorUtility() {
      this._length = 10;
      // eslint-disable-next-line
      this._timestamp = +new Date();
      this._getRandomInt = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      };
      this.generate = function () {
        var parts = this._timestamp.toString().split("").reverse();
        var id = "";
        for (var i = 0; i < this._length; ++i) {
          var index = this._getRandomInt(0, parts.length - 1);
          id += parts[index];
        }
        return id;
      };
    }
    this.uniqueIDGenerator = new IDGeneratorUtility();
  }

  isUndefinedOrNull(value) {
    return value === undefined || value === null || value === "undefined";
  }
  isNullOrEmpty(value) {
    return this.isUndefinedOrNull(value) || value.toString() === "";
  }
  isNullorWhiteSpace(value) {
    return this.isNullOrEmpty(value) || value.toString().trim().length === 0;
  }

  isArray = (value) => Array.isArray(value);

  focusByName(component, name) {
    try {
      const uiNode = $(ReactDOM.findDOMNode(component));
      var control = uiNode.find('[name="' + name + '"]');
      if (control !== undefined && control !== null && control.length > 0) {
        control.focus();
      }
    } catch (ex) { }
  }

  getUniqueID() {
    return this.uniqueIDGenerator.generate();
  }
  // method for deep cloning state begins *****************
  cloneState = (src) => _.cloneDeep(src);

  findComponentByNode(node) {
    try {
      const element = $(node).get(0);
      for (const key in element) {
        if (key.startsWith("__reactInternalInstance$")) {
          const fiberNode = element[key];
          const component = fiberNode && fiberNode._debugOwner;
          if (component) {
            return {
              name: component.type.displayName || component.type.name,
              state: component.stateNode,
            };
          }
          return {};
        }
      }
    } catch (ex) { }
    return {};
  }

  params(component) {
    var data = {};
    try {
      const uiNode = $(ReactDOM.findDOMNode(component));
      if (uiNode !== undefined && uiNode !== null) {
        var rows = uiNode.find("[data-row]");
        $.each(rows, (index, row) => {
          row = $(row);
          var id = row.attr("data-row");
          if (id === undefined || id === null || $.trim(id.toString()).length === 0) {
            row.attr("data-row", this.getUniqueID());
          }
        });
        var nodes = uiNode.find("input[name],textarea[name]");
        $.each(nodes, (index, node) => {
          try {
            node = $(node);
            var name = node.attr("name");
            if (name.startsWith("data:")) {
              name = name.replace("data:", "");
              var type = (node.attr("type") || "").toUpperCase();
              //var instance = pointer.findComponentByNode(node);
              var value = null;
              if (type === "CHECKBOX" || type === "RADIO") {
                value = node.is(":checked");
              } else {
                value = node.val();
              }
              if (value === "") {
                value = null;
              }
              var parts = name.split(".");
              var root = data;
              for (var i = 0; i < parts.length; i++) {
                var pathInstance;
                var last = i === parts.length - 1;
                var part = parts[i];
                if (part.endsWith("[]")) {
                  part = part.replace("[]", "");
                  pathInstance = root[part];
                  if (Array.isArray(pathInstance) === false) {
                    root[part] = [];
                  }
                  root = root[part];
                  if (last === true) {
                    root.push(value);
                  }
                } else {
                  if (last === true) {
                    root[part] = value;
                  } else {
                    pathInstance = root[part];
                    if (pathInstance === undefined || pathInstance === null) {
                      root[part] = {};
                    }
                    root = root[part];
                  }
                }
              }
            }
          } catch (ex) { }
        });
      }
    } catch (ex) { }
    return data;
  }

  // method for keyboard event handler starts ********************
  // all event lisening elemnets should have keyboard events also. but it should be only selected if the user press ENTER in the keyboard.
  // for this purpose this function is called
  isKeyBoardEnterPressed = (event) => {
    if (event.keyCode === 13 || event.key === "Enter") {
      event.preventDefault();
      return true;
    } else {
      return false;
    }
  };

  queryString() {
    var items = {};
    var query = window.location.href;
    if (query.indexOf("?") > -1) {
      try {
        var vars = query.split("?")[1].split("&");
        for (var i = 0; i < vars.length; i++) {
          try {
            var pair = vars[i].split("=");
            items[pair[0].toLowerCase()] = decodeURIComponent(pair[1]);
          } catch (ex) { }
        }
      } catch (ex) { }
    }
    return items;
  }

  loading(UIID, show) {
    let isMain = false;
    if (UIID === undefined || UIID === null || UIID.toString().trim().length === 0) {
      UIID = "mainui";
      isMain = true;
    }
    var loaderId = "__erp_loader_ui_" + UIID;
    var ui = $('.app-ui-container[identity="' + UIID + '"]');
    if (ui !== undefined && ui !== null) {
      ui.css("position", isMain === true ? "absolute" : "relative");
      var loader = ui.find("#" + loaderId + ".app-ui-loader");
      if (loader === undefined || loader === null || loader.length === 0) {
        loader = $(this._loadingHtml);
        loader.attr("id", loaderId);
        ui.append(loader);
      }
      if (show === undefined || show === null || show === true) {
        loader.show();
      } else {
        loader.hide();
      }
    }
  }

  getSelect2ItemByID(options, id) {
    if (this.isUndefinedOrNull(options) === false && this.isNullorWhiteSpace(id) === false) {
      if (this.isUndefinedOrNull(options.length) === false) {
        for (let i = 0; i < options.length; i++) {
          try {
            if (options[i].value === id) {
              return options[i];
            }
          } catch (ex) { }
        }
      }
    }
    return null;
  }

  validateDate = (date, day, directConvert) => {
    if (moment(date, "DD/MM/YYYY", true).isValid() === true || directConvert === true) {
      date = moment(date, "DD/MM/YYYY").toDate();
      if (!this.isNullorWhiteSpace(day) && Number.isInteger(day)) {
        if (day > 0) {
          return addDays(date, day);
        }
        if (day < 0) {
          day = Math.abs(day);
          return subDays(date, day);
        }
      }
      return date;
    }
    return "";
  };


  convertLocalArrayTimeToString(timeInput) {
    const [localHours, localMinutes] = timeInput;
    // Create a date object and set hours and minutes
    const date = new Date();
    date.setHours(localHours, localMinutes, 0);

    // Get the original hours and minutes
    const hours = date.getHours();
    const minutes = date.getMinutes();

    // Format minutes to ensure two digits
    const formattedHours = hours < 10 ? `0${hours}` : hours;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;


    return `${formattedHours}:${formattedMinutes}`;
  }

  convertLocalDateToDD_MMM_YYYY_String = (localDate) => { // FOR GRID VIEW PURPOSE
    if (!this.isNullOrEmpty(localDate)) {
      const [localYear, localMonth, localDay] = localDate;
      const dateTime = new Date(localYear, localMonth - 1, localDay);
      const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      ];

      const day = dateTime.getDate();
      const month = months[dateTime.getMonth()];
      const year = dateTime.getFullYear();
      return `${day}-${month}-${year}`;
    }
    return null;
  };

  convertLocalDateToDD_MMM_YYYY_HH_MM = (localDate) => { // FOR GRID VIEW PURPOSE
    if (!this.isNullOrEmpty(localDate)) {
      const [localYear, localMonth, localDay, localHour, localMinute] = localDate;
      const dateTime = new Date(localYear, localMonth - 1, localDay, localHour || 0, localMinute || 0);

      const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      ];

      const day = dateTime.getDate();
      const month = months[dateTime.getMonth()];
      const year = dateTime.getFullYear();
      const hours = (`0${dateTime.getHours()}`).slice(-2);
      const minutes = (`0${dateTime.getMinutes()}`).slice(-2);

      return `${day}-${month}-${year} ${" "} ${hours}:${minutes}`;
    }
    return null;
  };

  getdate = (localDate) => {
    if (!ERPUtils.isUndefinedOrNull(localDate)) {
      const parts = localDate.split("/");
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const newDate = `${parts[0]}-${months[Number(parts[1]) - 1]}-${parts[2]}`;
      return newDate;
    }
    return "";
  };

  // convert local date to date obj
  convertLocalDateToDateObj = (localDate) => {
    if (!this.isNullOrEmpty(localDate)) {
      const [localYear, localMonth, localDay, localHour, localMinute] = localDate;
      const newDate = new Date(localYear, localMonth - 1, localDay, localHour || 0, localMinute || 0);
      return newDate;
    }
    return null;
  };

  // convert date obj to local date
  convertDateObjToLocaleDate = (dateObj) => {
    if (!this.isNullorWhiteSpace(dateObj)) {
      // if (!this.isArrayOrObjectEmpty(dateObj)) {
      const localDate = [dateObj.getFullYear(), dateObj.getMonth() + 1, dateObj.getDate()];
      return localDate;
      // }
    }
    return [];
  };
  // convert dateTime obj to local date
  convertDateTimeObjToLocaleDate = (dateObj) => {
    if (!this.isNullorWhiteSpace(dateObj)) {
      const localDate = [dateObj.getFullYear(), dateObj.getMonth() + 1, dateObj.getDate(), dateObj.getHours(), dateObj.getMinutes()];
      return localDate;
    }
    return [];
  };

  //*****************Number Validation********************//
  isValidNumber = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105) && charCode !== 46 && charCode !== 37 && charCode !== 39) {
      event.preventDefault();
    } else {
      return true;
    }
  };

  //***************validate name***********************//
  validateName = (event) => {
    const inputKey = event.key;
    const validCharacters = /^[a-zA-Z\s]+$/;

    if (!validCharacters.test(inputKey)) {
      event.preventDefault();
    }
  };

  //***********Special character Validation************//
  validateSpecialCharacterInput = (event) => {
    const inputKey = event.key;
    const validCharacters = /^[a-zA-Z0-9]+$/;

    if (!validCharacters.test(inputKey)) {
      event.preventDefault();
    }
  };

  //*****************Presignes URL For Download********************** */

  getPresignedUrlDownload = (urlPath, codeProcess, fileName) => {
    return new Promise((resolve, reject) => {
      const previewUrlsList = [
        {
          originalFileName: fileName,
          actualPath: urlPath,
          processCode: codeProcess,
        }
      ];
      ApiGateway.post("fileUploadDownLoad/download/presigned", previewUrlsList, async (response) => {
        const preSignedUrl = response.data[0].preSignedUrl;
        // Download the file using the preSignedUrl
        const link = document.createElement("a");
        link.href = preSignedUrl;
        link.target = "_blank";
        link.download = fileName; // Use the original filename as the download filename
        document.body.appendChild(link);
        link.click();
        link.remove();
        resolve(preSignedUrl);
      }, "Protected");
    });
  };
  //*****************Presignes URL For View********************** */
  getPresignedUrl = (urlPath, codeProcess, fileName) => new Promise((resolve, reject) => {
    const previewUrlsList = [
      {
        originalFileName: fileName,
        actualPath: urlPath,
        processCode: codeProcess,
      },
    ];
    // Make API request to get the presigned URL for file download
    ApiGateway.post("fileUploadDownLoad/download/presigned", previewUrlsList, async (response) => {
      const presigned = response.data[0].preSignedUrl;
      // Download the file using the presigned URL

      resolve(presigned);
    }, "Protected");
  });

  // to filter out the dropdown options eg:- inaddMore ui
  getUnselectedOptions = (options, array, key) => {
    // options - the dropdown list data
    // array - the particular array of data which the values needs to checked
    // key - the key name  of the each object where the value should be targeted
    // ************ example *******
    //   let options = [
    //     {value:"1",label:"abc"},
    //     {value:"2",label:"xcxc"},
    //     {value:"3",label:"fdf"},
    //     {value:"4",label:"gfg"},
    //     {value:"5",label:"nbn"},
    // ]
    // let data = [
    //     {testKey: {value:"5",label:"nbn"}},
    //      {testKey: [{value:"3",label:"nbn"}]},
    //      {testKey: "1"},
    //     {testKey: 2},
    // ]
    // key = "testKey";

    // ************ end of example *******
    const allSelectedOPtions = [];
    for (let i = 0; i < options.length; i++) {
      for (let j = 0; j < array?.length; j++) {
        if (this.isNullorWhiteSpace(array[j][key]) === false) {
          if (typeof array[j][key] === "object" && Array.isArray(array[j][key]) === false) {
            if (options[i].value === array[j][key].value) {
              allSelectedOPtions.push(options[i]);
            }
          } else if (Array.isArray(array[j][key])) {
            for (let index = 0; index < array[j][key].length; index++) {
              if (options[i].value === array[j][key][index].value) {
                allSelectedOPtions.push(options[i]);
              }
            }
          } else if (typeof array[j][key] === "string") {
            if (options[i].value === array[j][key]) {
              allSelectedOPtions.push(options[i]);
            }
          } else if (typeof array[j][key] === "number") {
            if (parseInt(options[i].value, 10) === parseInt(array[j][key], 10)) {
              allSelectedOPtions.push(options[i]);
            }
          }
        }
      }
    }
    let filteredArray = [...options];
    for (let i = 0; i < options.length; i++) {
      for (let j = 0; j < allSelectedOPtions.length; j++) {
        filteredArray = filteredArray.filter((a) => a.value !== allSelectedOPtions[j].value);
      }
    }
    return filteredArray;
  };

}
export default new ERPUtils();

